export const FLOOR_PLAN_EDITOR_MODES = {
  DESIGNER: 'designer',
  AI_CREATOR: 'ai_creator',
  ROOM_IMAGE: 'room_image',
};
